import React from 'react';

interface TestimonialCardProps {
  company: string;
  testimonial: string;
}

function TestimonialCard({ company, testimonial }: TestimonialCardProps) {
  return (
    <div className="testimonial-card spotlight-card bg-card p-8 rounded-lg relative border border-zinc-700 hover:border-[#FDCB12] transition-colors transform hover:-translate-y-1 duration-500">
      <p className="text-gray-300 italic text-lg leading-relaxed mb-6">“{testimonial}”</p>
      <div className="pt-4 border-t border-zinc-700">
        <p className="text-[#FDCB12] font-semibold tracking-wide">{company}</p>
      </div>
    </div>
  );
}

export default TestimonialCard;
